import { Avatar, Box, Button, Divider, Drawer, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Modal, Paper, Stack, styled, TextField, Tooltip, Typography } from "@mui/material";
import {
    AddCardRounded,
    DarkModeRounded,
    DownloadingRounded,
    LightModeRounded,
    LogoutRounded,
    MenuRounded,
    NotificationsRounded,
    PeopleRounded,
    ShoppingBagRounded,
    StorageRounded,
    SupervisedUserCircleRounded,
    WorkspacePremiumRounded
} from "@mui/icons-material";
import Sidebar from "./sidebar";
import { useEffect, useState } from "react";
import useThemeStore from "../../../store/theme";
import { useUser } from "../../../lib/hooks";
import { Link, useNavigate } from "react-router-dom";
import SwitchButton from "../../common/switchButton";
import { useAnimate } from "framer-motion";
import ConfirmDialog from "../../common/confirmDialog";
import Toasty from "../../../theme/components/Toasty";
import InputFieldModal from "../drive/inputFieldModal";
import { NumericFormatCustom } from "../../common/formatInputs";
import {
    changeMasterAccount,
    getUsedDriveSpace,
    getUserBalance,
    getUserInformation,
    pay
} from "../../../lib/services/drive";
import { LoadingButton } from "../../../theme/components/LoadingButton";
import Cookies from 'js-cookie';
import { setRefreshToken, setToken, setUserData } from "../../../lib/services/jwtService";
import axios from "axios";
import useMainStore from "../../../store";
import LoadingSpinner from "../../loading/loadingSpinner";

const Header = () => {

    const user = useUser({ redirectTo: '/drive/login' });
    const [pageTitle, setPageTitle] = useState('درایو میلفا');
    const [usedSpaceText, setUsedSpaceText] = useState(<LoadingSpinner sx={{ display: "inline", ml: "2rem" }} />);
    const [balance, setBalance] = useState(user?.creditBalance);
    const [menuOpen, setMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [logoutConfirm, setLogoutConfirm] = useState(false);
    const [addBalanceModal, setAddBalanceModal] = useState(false);
    const [pending, setPending] = useState(false);
    const [success, setSuccess] = useState(false);

    const [changeAccountModal, setChangeAccountModal] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState('');

    const open = Boolean(anchorEl);
    const { mode, setMode } = useThemeStore();
    const [scope, animate] = useAnimate()
    const navigate = useNavigate();
    const { setSessionUpdated } = useMainStore();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleGotoBalancePayment = async (amount) => {
        setPending(true);
        try {
            const { data } = await pay('balance', { amount });
            if (data?.isSuccess) {
                if (data.value?.gatewayUrl) window.location.href = data.value.gatewayUrl;
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد')
        }
        setPending(false);
    }
    const handleChangeMasterAccount = async (e) => {
        e.preventDefault();
        if (!selectedEmail) return;
        setPending(true);
        try {
            const refreshToken = Cookies.get('refresh-token');
            const { data } = await changeMasterAccount(selectedEmail, refreshToken);
            if (data?.isSuccess) {
                const userData = data.value
                const { access_Token: accessToken, refresh_Token } = userData;
                setToken(accessToken);
                setRefreshToken(refresh_Token);
                axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
                delete userData.refresh_Token;
                delete userData.access_Token;
                userData.role = 'user';
                setUserData(JSON.stringify(userData));
                setSessionUpdated();
                if (data.successMessage) Toasty.success(data.successMessage);
                else Toasty.success('حساب شما با موفقیت تغییر کرد، لطفا منتظر بمانید..');
                setSuccess(true);
                setTimeout(() => {
                    setChangeAccountModal(false);
                    window.location.reload();
                }, 1500);
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد')
        }
        setPending(false);
    }

    async function getUsedSpace() {
        try {
            const { data } = await getUsedDriveSpace();
            if (data?.isSuccess) {
                const { driveSapce: driveSpace, usedPercentage } = data.value;
                const calculateSpace = driveSpace / 1024;
                setUsedSpaceText(`${Math.abs(Math.ceil(usedPercentage)).toLocaleString('fa-IR')} درصد از ${calculateSpace.toLocaleString('fa-IR')} گیگ`);
            } else {
                setUsedSpaceText('نامشخص');
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            setUsedSpaceText('نامشخص');
            Toasty.error('خطایی غیر منتظره رخ داد')
        }
    }
    async function getBalance() {
        setPending('balance')
        try {
            const { data } = await getUserInformation();
            if (data?.isSuccess) {
                if (!data.value) return;
                setUserData(JSON.stringify(data.value));
                setBalance(data?.value?.creditBalance);
            }
        } catch (err) {
            console.log(err);
        }
        setPending(false);
    }

    useEffect(() => {
        getUsedSpace();
        getBalance();
        let target = document.querySelector('title');
        let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                setPageTitle(document.title);
                animate('h1', { opacity: [0, 1] });
            });
        });
        let config = { childList: true, };
        observer.observe(target, config);
    }, []);

    return (
        <>
            <Root>
                <Stack ref={scope} direction="row" alignItems="center" spacing={2}>
                    <IconButton onClick={() => setMenuOpen(true)} sx={{ display: { lg: "none" } }}>
                        <MenuRounded sx={{ fontSize: "2rem" }} />
                    </IconButton>
                    <Typography variant="h1" fontSize={{ xs: "1.05rem", lg: "1.4rem" }} fontWeight={700}>{pageTitle}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Box display={{ xs: "none", lg: "block" }}>
                        <Tooltip title={mode === 'light' ? 'تغییر تم به تاریک' : 'تغییر تم به روشن'}>
                            <SwitchButton onClick={() => setMode(mode === 'light' ? 'dark' : 'light')}>
                                {
                                    mode === 'light'
                                        ?
                                        <>
                                            <LightModeRounded />
                                            <Typography ml={.5} fontSize=".85rem" sx={{ display: { lg: "none" } }}>تم روشن</Typography>
                                        </>
                                        :
                                        <>
                                            <DarkModeRounded />
                                            <Typography ml={.5} fontSize=".85rem" sx={{ display: { lg: "none" } }}>تم تاریک</Typography>
                                        </>
                                }
                            </SwitchButton>
                        </Tooltip>
                    </Box>
                    <Tooltip title="اعلانات">
                        <IconButton>
                            <NotificationsRounded color="warning" sx={{ fontSize: "2rem" }} />
                        </IconButton>
                    </Tooltip>
                    <IconButton sx={{ p: 0 }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            flexDirection={{ xs: "column", lg: "row" }}
                            id="profile-menu-button"
                            aria-controls={open ? 'profile-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                        >
                            {user.Avtar
                                ?
                                <Avatar src={user.avatar} />
                                :
                                <Avatar>{user.firstName ? user.firstName[0] : "A"}</Avatar>
                            }
                        </Box>
                        <Menu
                            id="profile-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            PaperProps={{ sx: { borderRadius: 2 }, elevation: 25 }}>
                            <MenuItem disabled sx={{ opacity: "1!important" }}>
                                <Box>
                                    <Typography fontSize=".925rem">حساب فعلی: {user?.masterEmailAddress ? user.masterEmailAddress : "نامشخص"}</Typography>
                                    <Typography mt={.5} fontSize=".925rem">شارژ فعلی: {pending === 'balance' ? 'درحال بارگذاری..' : balance ? `${balance.toLocaleString('fa-IR')} ریال` : "۰ ریال"}</Typography>
                                </Box>
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => { handleClose(); setChangeAccountModal(true); }}>
                                <ListItemIcon>
                                    <PeopleRounded color="info" fontSize="small" />
                                </ListItemIcon>
                                <ListItemText disableTypography sx={{ fontSize: ".875rem" }}>انتخاب حساب</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={handleClose}>
                                <Link to="/drive/settings" style={{ display: 'flex' }}>
                                    <ListItemIcon>
                                        <SupervisedUserCircleRounded color="primary" fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText disableTypography sx={{ fontSize: ".875rem" }}>ویرایش پروفایل</ListItemText>
                                </Link>
                            </MenuItem>
                            <MenuItem onClick={() => { handleClose(); setAddBalanceModal(true) }}>
                                <ListItemIcon>
                                    <AddCardRounded color="success" fontSize="small" />
                                </ListItemIcon>
                                <ListItemText disableTypography sx={{ fontSize: ".875rem" }}>شارژ حساب‌ (حساب فعلی)</ListItemText>
                            </MenuItem>
                            <Link to="/drive/plans">
                                <MenuItem onClick={handleClose}>
                                    <ListItemIcon>
                                        <WorkspacePremiumRounded color="warning" fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText disableTypography sx={{ fontSize: ".875rem" }}>پلن فعال: {user?.userActivePack?.name ? user.userActivePack.name : "نامشخص"}</ListItemText>
                                </MenuItem>
                            </Link>
                            <Link to="/drive/plans">
                                <MenuItem onClick={handleClose}>
                                    <ListItemIcon>
                                        <ShoppingBagRounded color="success" fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText disableTypography sx={{ fontSize: ".875rem" }}>خرید بسته جدید</ListItemText>
                                </MenuItem>
                            </Link>
                            <MenuItem onClick={handleClose}>
                                <ListItemIcon>
                                    <StorageRounded color="info" fontSize="small" />
                                </ListItemIcon>
                                <ListItemText disableTypography sx={{ fontSize: ".875rem" }}>حجم استفاده شده: {usedSpaceText}</ListItemText>
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => { handleClose(); setLogoutConfirm(true) }}>
                                <ListItemIcon>
                                    <LogoutRounded color="error" fontSize="small" />
                                </ListItemIcon>
                                <ListItemText disableTypography sx={{ fontSize: ".875rem" }}>خروج از حساب</ListItemText>
                            </MenuItem>
                        </Menu>
                    </IconButton>
                </Stack>
            </Root>
            <Drawer open={menuOpen} onClose={() => setMenuOpen(false)} sx={{ display: { lg: "none" } }} PaperProps={{ sx: { p: 2.5, width: "75%" } }}>
                <Sidebar sx={{ mt: 2.5, display: { xs: "block", lg: "none" } }} onItemClick={() => setMenuOpen(false)} />
                <SwitchButton onClick={() => setMode(mode === 'light' ? 'dark' : 'light')} sx={{ display: { lg: "none" } }}>
                    {
                        mode === 'light'
                            ?
                            <>
                                <LightModeRounded />
                                <Typography ml={.5} fontSize=".85rem" sx={{ display: { lg: "none" } }}>تم روشن</Typography>
                            </>
                            :
                            <>
                                <DarkModeRounded />
                                <Typography ml={.5} fontSize=".85rem" sx={{ display: { lg: "none" } }}>تم تاریک</Typography>
                            </>
                    }
                </SwitchButton>
                <Button onClick={() => setLogoutConfirm(true)} color="error" startIcon={<LogoutRounded />} sx={{ mt: 5 }}>خروج از حساب</Button>
            </Drawer>
            {/* Logout Confirm */}
            <ConfirmDialog
                open={logoutConfirm}
                onClose={() => setLogoutConfirm(false)}
                color="error"
                title="مطمئنی می خوای از حسابت خارج بشی؟!"
                onConfirm={() => { navigate("/logout", { replace: true }); setLogoutConfirm(false) }} />

            {/* Add Balance Input */}
            <InputFieldModal
                open={addBalanceModal}
                onClose={() => setAddBalanceModal(false)}
                pending={pending}
                inputProps={{
                    label: "مبلغ", placeholder: "لطفا مبلغ مورد نظر خود را وارد کنید",
                    InputProps: { inputComponent: NumericFormatCustom },
                    inputProps: { allowLeadingZeros: false, suffix: " ریال", type: "tel" },
                }}
                onConfirm={(value) => handleGotoBalancePayment(value)} />

            {/* Change Master Account */}
            <StyledModal open={changeAccountModal} onClose={() => setChangeAccountModal(false)}>
                <Paper elevation={25} sx={{ width: { xs: "90%", lg: "auto" }, minWidth: { lg: "25%" }, maxWidth: { xs: "90%", lg: "85%", xl: "75%", xxl: "65%" }, maxHeight: "90%", minHeight: "50%", p: 2.5, borderRadius: 2.5, overflowY: "auto" }}>
                    <Typography textAlign="center" fontWeight={500}>انتخاب حساب</Typography>
                    <Grid mt={1} component="form" onSubmit={handleChangeMasterAccount} container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                value={selectedEmail} onChange={(e) => setSelectedEmail(e.target.value)}
                                select fullWidth required
                                label="ایمیل">
                                {user?.emailAddress?.length && (
                                    user.emailAddress.map((email, ind) => (
                                        <MenuItem key={ind} value={email}>{email}</MenuItem>
                                    ))
                                )}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <LoadingButton
                                type="submit"
                                loading={pending} success={success}
                                fullWidth disableElevation
                                sx={{ py: 1.5 }}
                            >اعمال</LoadingButton>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                onClick={() => setChangeAccountModal(false)}
                                variant="outlined"
                                fullWidth disableElevation
                                sx={{ py: 1.5 }}
                            >انصراف</Button>
                        </Grid>
                    </Grid>
                </Paper>
            </StyledModal>
        </>
    )
}
export default Header;

const Root = styled('header')(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "fixed",
    top: 0,
    right: 0,
    padding: 16,
    width: "100%",
    height: "5rem",
    background: theme.palette.background.box,
    boxShadow: "0 2px 16px -2px rgb(33 33 33 / 15%)",
    [theme.breakpoints.up('lg')]: {
        padding: 24,
        height: "6rem",
        width: "calc(100% - 20vw)",
    },
    [theme.breakpoints.up('xl')]: {
        width: "calc(100% - 18vw)",
    },
    zIndex: 1000,
}));
const StyledModal = styled(Modal)(({ theme }) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
